import React from "react";

export default function DotOneClassy() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 35 35"
      fill="none"
    >
      <path
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={5}
        d="M3.431 17.524c0-7.848 6.374-14.21 14.222-14.21 7.86 0 14.244 6.372 14.244 14.233v14.188H17.642c-7.848 0-14.21-6.362-14.21-14.21Z"
      />
      <path fill="#DDE0E4" d="M11.867 11.737h11.597v11.579H11.867z" />
    </svg>
  );
}
